import {
  Button,
  Form,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { chooseFormByType, setQuestionGroupFormValues } from "./helpers";
import { QuestionsByOrder } from "./groups-form-type/QuestionsByOrder";
import { useTranslation } from "react-i18next";
import { useEditExamGroup } from "@hooks";
import { ExamGroup } from "@types";
import { motion } from "framer-motion";
import { MyFormItem, MyFormItemGroup } from "@components";

interface Props {
  examGroup: ExamGroup;
  setIsModalGroupSettings: React.Dispatch<React.SetStateAction<boolean>>;
  examPeriodScreen?: boolean;
}

export const ExamQuestionGroupSettingsForm = ({ examGroup, setIsModalGroupSettings, examPeriodScreen }: Props) => {
  const { t } = useTranslation();
  const [groupSettingsForm] = Form.useForm();
  const [questionGroupType, setQuestionGroupType] = useState(examGroup.examGroupProperties?.examGroupType || 1);
  const editExamGroup = useEditExamGroup(examPeriodScreen);

  const onFinish = (values: any) => {
    if (questionGroupType === 1) {
      examGroup.numberOfQuestions = examGroup.numberOfQuestionsInGroup;
    }
    examGroup.examGroupProperties = { ...examGroup.examGroupProperties, ...values.examGroupProperties };
    examGroup.examGroupProperties.examGroupType = values.examGroupProperties.examGroupType;
    examGroup.examGroupProperties.passPercentage = values.percentageToPass;
    examGroup.examGroupProperties.timeInSeconds = values.timeInSeconds;
    examGroup.timeInSeconds = values.timeInSeconds;
    examGroup.percentageToPass = values.percentageToPass;
    console.log("examGroup", examGroup);
    editExamGroup.mutate({ ...examGroup }, {
      onSuccess() {
        setIsModalGroupSettings(false);
      }
    });
  }

  useEffect(() => {
    setQuestionGroupFormValues(groupSettingsForm, examGroup)
  }, [examGroup])

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Form layout="vertical" form={groupSettingsForm} onFinish={onFinish}>
        <MyFormItemGroup prefix={"examGroupProperties"}>
          <MyFormItem
            label={t("forms.questionGroup.chooseQuestion")}
            name={["examGroupType"]}
            initialValue={1}
            rules={[{ required: true, message: t("forms.questionGroup.chooseQuestion") }]}
          >
            <Select
              onChange={(val) => setQuestionGroupType(val)}
              options={[
                {
                  label: t("forms.questionGroup.byOrder"),
                  value: 1,
                },
                {
                  label: t("forms.questionGroup.randomOrder"),
                  value: 2,
                },
                {
                  label: t("forms.questionGroup.certainOrder"),
                  value: 3,
                },
                {
                  label: t("forms.questionGroup.skip"),
                  value: 4,
                },
              ]}
            />
          </MyFormItem>
        </MyFormItemGroup>

        {chooseFormByType(questionGroupType, groupSettingsForm, examGroup)}

        {questionGroupType === 4 ? <></> : <QuestionsByOrder examGroup={examGroup} form={groupSettingsForm} />}

        <Form.Item
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            marginBottom: 0,
            marginTop: 8,
          }}
        >
          <Button type="primary" htmlType="submit" loading={editExamGroup.isPending}>
            {t("forms.questionGroup.save")}
          </Button>
        </Form.Item>
      </Form>
    </motion.div>
  );
};
